<template>
  <div>
    <div class="d-flex flex-column">
      <div v-if="loading" class="alert alert-secondary">
        <div class="mx-auto my-auto">
          <i class="fa fa-spinner fa-pulse"></i> Loading...
        </div>
      </div>
      <vue-pdf
        class="mb-2 card shadow-sm overflow-hidden"
        v-for="i in numPages"
        :key="i"
        :src="loadingTask"
        :page="i"
      ></vue-pdf>
    </div>
  </div>
</template>

<script>
import vuePdf from "vue-pdf";

export default {
  components: {
    vuePdf
  },
  props: {
    file: String,
    downloadable: {
      type: Boolean,
      default: false
    },
    blob: {
      // type: String,
      default: false
    }
  },
  data: () => ({
    loading: false,
    numPages: undefined,
    loadingTask: null,
    blobData: null
  }),
  async mounted() {
    this.loading = true;

    this.blobData = this.blob;

    if (!this.blob) {
      const { data } = await this.axios({
        url: "/api/products/files/" + encodeURIComponent(this.file),
        method: "POST",
        responseType: "blob"
      });
      this.blobData = data;
    }

    const reader = new FileReader();
    reader.readAsDataURL(this.blobData);
    reader.onload = () => {
      const bin = atob(reader.result.split(",", 2)[1]);
      this.$emit("b64", reader.result);
      this.loading = false;
      this.loadingTask = vuePdf.createLoadingTask({ data: bin });
      this.loadingTask.promise.then(pdf => {
        this.numPages = pdf.numPages;
      });
    };
  }
};
</script>
<style lang="scss">
.annotationLayer,
.linkAnnotation {
  display: none !important;
}
</style>
